import { useEffect, useState } from "react";
import Footer from "../../components/footer";
import { Button } from "../../components/ui/button";
import { NavLink } from "react-router-dom";
import { Icons } from "../../assets/icons";
import { getSection1 } from "../../api/aboutPage/section1";
import { getSection2 } from "../../api/aboutPage/section2";
import { getSection3 } from "../../api/aboutPage/section3";
import { getSection4 } from "../../api/aboutPage/section4";
import { getSection5 } from "../../api/aboutPage/section5";
import { getSection6 } from "../../api/aboutPage/section6";
import NameCard from "../../components/namecard";
import VideoPlayer from "../../components/videoPlayer";
import explordBanner from "../../assets/images/explordBanner.png";
//@ts-ignore
import captions from "../../assets/transcript/lilly.vtt";
import { convertVttToTranscript, TranscriptEntry } from "../../utils/vttParser";
import worldMap from "@highcharts/map-collection/custom/world.geo.json";
import WorldMap from "./WorldMap";
import { useDocumentTitle } from "../../hooks/useDocumentTitle";

// import { Caption, parseVTT } from "../../utils/vttParser";

const mapOptions = {
  chart: { map: worldMap },
  title: { text: "Global Presence" },
  series: [
    {
      name: "World",
      mapData: worldMap,
      color: "#E6E6E6",
      borderColor: "#AAAAAA",
    },
  ],
};

const AboutPage = () => {
  useDocumentTitle("About Lilly ExploR&D");

  const [loading1, setLoading1] = useState(true);
  const [loading2, setLoading2] = useState(true);
  const [loading3, setLoading3] = useState(true);
  const [loading4, setLoading4] = useState(true);
  const [loading5, setLoading5] = useState(true);
  const [loading6, setLoading6] = useState(true);

  const [data1, setData1] = useState<any>();
  const [data2, setData2] = useState<any>();
  const [data3, setData3] = useState<any>();
  const [data4, setData4] = useState<any>();
  const [data5, setData5] = useState<any>();
  const [data6, setData6] = useState<any>();

  const [captionsText, setCaptionsText] = useState<TranscriptEntry[]>([]);
  const [showTranscript, setShowTranscript] = useState(false);

  const fetchData = () => {
    getSection1().then((res) => {
      setData1(res.data);
      setLoading1(false);
    });
    getSection2().then((res) => {
      setData2(res.data);
      setLoading2(false);
    });
    getSection3().then((res) => {
      setData3(res.data);
      setLoading3(false);
    });
    getSection4().then((res) => {
      setData4(res.data);
      setLoading4(false);
    });
    getSection5().then((res) => {
      setData5(res.data);
      setLoading5(false);
    });
    getSection6().then((res) => {
      setData6(res.data);
      setLoading6(false);
    });
  };
  const fetchVTT = async () => {
    try {
      const response = await fetch(captions); // Path relative to public folder
      const vttContent = await response.text();
      // const parsedCaptions = parseVTT(vttContent);
      const parsedCaptions = convertVttToTranscript(vttContent);
      setCaptionsText(parsedCaptions);
    } catch (error) {
      console.error("Error loading VTT file:", error);
    }
  };
  useEffect(() => {
    fetchVTT();
    fetchData();
  }, []);
  return (
    <>
      <div className="md:pt-12 pt-4">
        {!loading1 && (
          <section className="">
            <div className="grid md:grid-cols-2 md:gap-12 gap-8 items-center md:px-12 px-4">
              <div className="md:hidden">
                <div className="relative h-full w-full ">
                  <img
                    className="rounded-[8px] md:rounded-[6px]"
                    src={`${process.env.REACT_APP_API_BASE_URL}${data1.Image_main.url}`}
                    alt={data1.Image_main.alternativeText}
                  />
                  <div className="absolute top-0 left-0 p-4 flex items-center justify-center bg-bg-neutral_rose rounded-[8px]">
                    <div className="text-body-text-lilly_red">
                      <img
                        className="h-10 w-10 object-cover"
                        src={`${process.env.REACT_APP_API_BASE_URL}${data1.Icon.url}`}
                        alt={data1?.Icon?.alternativeText ?? "about page icon"}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <h1>
                  <div className="md:text-5xl text-3xl tracking-tighter leading-8 font-light">
                    {data1.Header_non_highlighted}&nbsp;
                    <span className="font-semibold">
                      {data1.Header_highlighted}
                    </span>
                  </div>
                </h1>

                <div className="md:mt-8 mt-6 md:max-w-[32rem]">
                  {data1.Description}
                </div>
              </div>

              <div className="relative hidden md:block h-full">
                <img
                  className="h-full w-full object-cover rounded-[8px] md:rounded-[6px]"
                  src={`${process.env.REACT_APP_API_BASE_URL}${data1.Image_main.url}`}
                  alt={data1.Image_main.alternativeText}
                />

                <div
                  className="absolute right-full h-20 w-20 flex items-center justify-center bg-bg-neutral_rose rounded-[8px]"
                  style={{
                    transformStyle: "preserve-3d",
                  }}
                >
                  <div className="text-body-text-lilly_red">
                    <img
                      className="h-12 w-12"
                      src={`${process.env.REACT_APP_API_BASE_URL}${data1.Icon.url}`}
                      alt={data1?.Icon?.alternativeText ?? "about page icon"}
                    />
                  </div>
                  <div
                    className="absolute right-[80%] top-[80%] h-80 w-72"
                    style={{
                      transform: "translateZ(-10px)",
                    }}
                  >
                    {!loading2 && (
                      <img
                        src={`${process.env.REACT_APP_API_BASE_URL}${data2.Image.url}`}
                        alt={
                          data2?.Image?.alternativeText ?? "about page image"
                        }
                        className="rounded-[8px] md:rounded-[6px]"
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="md:hidden my-8">
              {!loading2 && (
                <img
                  className="w-full"
                  src={`${process.env.REACT_APP_API_BASE_URL}${data2.Image.url}`}
                  alt={data2?.Image?.alternativeText ?? "about page image"}
                />
              )}
            </div>
          </section>
        )}
        {!loading2 && (
          <section className="md:px-12 px-4 md:mt-48 py-16 md:py-0">
            <div className="grid md:grid-cols-2 grid-cols-1 gap-12 items-center">
              <div className="hidden md:block"></div>
              <div>
                <h2 className="md:text-3xl text-2xl font-bold md:tracking-tight leading-8">
                  {data2.Header}
                </h2>
                <div>
                  {data2.Support.map((el: any, index: number) => (
                    <div
                      className={`flex gap-4 py-4 ${index !== 0 ? "border-t border-border-gray20" : ""}`}
                    >
                      <div className="">
                        <img
                          className="md:w-6 w-5 mt-1"
                          src={`${process.env.REACT_APP_API_BASE_URL}${el.Icon.url}`}
                          alt={el?.Icon?.alternativeText ?? "about page icon"}
                        />
                      </div>
                      <div className="flex-1">
                        <div className="md:text-2xl text-xl">{el.Header}</div>
                        <div className="mt-2">{el.Description}</div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="mt-4 w-full">
                  <NavLink
                    to={data2.Button_link}
                    data-gtm-id="item-28"
                    // className="w-full md:w-fit"
                    className="flex w-full gap-2 items-center md:justify-start justify-between"
                  >
                    <div className="flex gap-2 items-center md:justify-start justify-between w-full md:w-fit border border-border-lilly_red bg-background hover:bg-accent hover:text-accent-foreground text-body-text-lilly_red px-4 py-2 text-sm font-medium">
                      {data2.Button_text}
                      <Icons.ChevronRight />
                    </div>
                  </NavLink>
                </div>
              </div>
            </div>
          </section>
        )}
        {!loading3 && (
          <section className="md:px-12 px-4 md:mt-20">
            <h2
              id="video-title"
              className="md:text-3xl text-2xl font-bold tracking-tight"
            >
              {data3.Header}
            </h2>
            <div className="my-4 max-w-[50rem]">{data3.Description}</div>
            <div className="grid grid-cols-4 gap-12 items-start mt-8 2xl:max-w-[90rem] mx-auto">
              <div className="2xl:col-span-3 col-span-4">
                <div
                  className="w-full h-full"
                  style={{
                    position: "relative",
                    // paddingBottom: "40%",
                    // height: 0,
                    // overflow: "hidden",
                    // background: "gray",
                  }}
                >
                  <VideoPlayer
                    videoUrl={`${process.env.REACT_APP_API_BASE_URL}${data3.Video.url}`}
                    captionsUrl={captions}
                    altText={data3.Video.alternativeText}
                    captionsLang="en"
                    initialPlaybackRate={1}
                    banner={explordBanner}
                  />
                </div>
              </div>
              <div className="2xl:col-span-1 col-span-4 border border-border-gray20 py-4 ">
                <div className="flex justify-between items-center xl:px-6 px-4">
                  <div
                    id="about-transcript-heading"
                    className="md:text-2xl text-xl font-medium leading-8 md:tracking-tight"
                  >
                    Transcript
                  </div>
                  <button
                    onClick={() => setShowTranscript(!showTranscript)}
                    className="text-sm text-body-text-lilly_red flex items-center gap-2 2xl:hidden"
                    aria-label={
                      showTranscript ? "Hide Transcript" : "Show Transcript"
                    }
                    data-gtm-id="item-50"
                  >
                    {showTranscript ? "Hide" : "Show"}
                    {showTranscript ? (
                      <Icons.ChevronUp size={16} />
                    ) : (
                      <Icons.ChevronDown size={16} />
                    )}
                  </button>
                </div>

                <div
                  className={`my-4 transition-all duration-300 ease-in-out ${showTranscript ? "block" : "hidden"} 2xl:hidden`}
                >
                  <div className="max-h-[30rem] overflow-y-auto xl:px-6 px-4">
                    {captionsText.map((el, index) => (
                      <div key={index} className="mb-2 text-sm">
                        {el.speaker && (
                          <div className="font-medium">{el.speaker}:</div>
                        )}
                        <div>{el.speech}</div>
                      </div>
                    ))}
                  </div>
                </div>
                <div
                  className={`my-4 hidden 2xl:block `}
                  role="region"
                  aria-labelledby="about-transcript-heading"
                  tabIndex={0}
                  aria-live="polite"
                >
                  <div className="max-h-[30rem] overflow-y-auto xl:px-6 px-4">
                    {captionsText.map((el, index) => (
                      <div key={index} className="mb-2 text-sm">
                        {el.speaker && (
                          <div className="font-medium">{el.speaker}:</div>
                        )}
                        <div>{el.speech}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </section>
        )}
        {!loading4 && (
          <section className="md:px-12 px-4 md:my-20 my-10">
            <h2 className="md:text-3xl text-2xl font-bold md:tracking-tight">
              {data4.Header}
            </h2>
            <div className="grid md:grid-cols-3 gap-8 max-w-[80rem] m-auto mt-8">
              {data4.Solutions.map((solution: any, index: number) => (
                <div
                  className="border border-border-gray90 rounded-[8px] px-8 py-8 bg-bg-neutral_rose_tint"
                  style={{
                    boxShadow: "4px 4px 0px 0px #FBCFC8",
                  }}
                >
                  <div className="flex justify-center">
                    <img
                      className="w-16 mt-1"
                      src={`${process.env.REACT_APP_API_BASE_URL}${solution.Icon.url}`}
                      alt={
                        solution?.Icon?.alternativeText ??
                        `solution icon ${index + 1}`
                      }
                    />
                  </div>
                  <h3 className="text-2xl mt-4">{solution.Header}</h3>
                  <div>
                    {solution.Solutions_details.map(
                      (details: any, index: number) => (
                        <div className="mt-4">
                          <div className="text-base font-semibold">
                            {details.Header}
                          </div>
                          <div>{details.Description}</div>
                        </div>
                      ),
                    )}
                  </div>
                </div>
              ))}
            </div>
          </section>
        )}
        {!loading5 && (
          <section className="md:px-12 px-4 md:mt-20 bg-bg-neutral_rose_tint py-8">
            <h2 className="md:text-3xl text-2xl font-bold md:tracking-tight">
              {data5.Header}
            </h2>
            <div>
              <h3 className="md:text-2xl text-xl border-b border-border-gray20 mt-8 leading-8 pb-4">
                Head of Lilly ExploR&D
              </h3>
              <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 mt-8">
                {data5.Head.map((leader: any) => (
                  <NameCard leader={leader} type={"Head of ExploR&D"} />
                ))}
              </div>
            </div>
            <div className="mt-16">
              <h3 className="text-2xl border-b border-border-gray20 mt-8 leading-8 pb-4">
                External Partnering Team
              </h3>
              <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 mt-8">
                {data5.External_Partnering.map((leader: any) => (
                  <NameCard leader={leader} type="Pre-Clinical" />
                ))}
              </div>
            </div>
            <div className="mt-16">
              <h3 className="text-2xl border-b border-border-gray20 mt-8 leading-8 pb-4">
                Leadership Team
              </h3>
              <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8 mt-8">
                {data5.Pre_clinical.map((leader: any) => (
                  <NameCard leader={leader} type="Pre-Clinical" />
                ))}
              </div>
            </div>
          </section>
        )}
        {!loading6 && (
          <section className="md:px-12 px-4 md:pt-20 py-20 bg-bg-neutral_stone_tint h-full">
            <h2 className="md:text-3xl text-2xl font-bold md:tracking-tight lg:w-2/5 text-wrap">
              Collaborating with biotechs across {data6.TotalCountries}{" "}
              countries worldwide
            </h2>
            <WorldMap data={data6} />
          </section>
        )}
      </div>
      <Footer />
    </>
  );
};

export default AboutPage;
